// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
import fetchGraphqlClient from '@workspace/nextjs_utils/src/fetchGraphqlClient';
import useMutation, { type MutationOptions } from '../../useMutation';
import { RegisterMutationDocument, type RegisterMutation, type RegisterMutationVariables } from './RegisterMutation';

export async function getRegisterMutationClient(variables: RegisterMutationVariables) {
  return fetchGraphqlClient<RegisterMutation, RegisterMutationVariables>(RegisterMutationDocument, "RegisterMutation", { variables });
}
export const useRegisterMutation = (options?: MutationOptions) => useMutation<RegisterMutation, RegisterMutationVariables>(getRegisterMutationClient, options);